import { costByCategorySetupSelector } from "./costByCategorySetupSelector";
import { RootState } from "../../../../store";
import { CostByCategoryWidgetSetupType } from "../../../utils/types/setups/costByCategorySetupType";

export const costByCategorySetupPropertyByKeySelector =
  (key: keyof CostByCategoryWidgetSetupType) =>
  (state: RootState): any => {
    const setup = costByCategorySetupSelector(state);

    if (!setup) {
      return null;
    }

    return setup[key];
  };
